import { ChangeDetectorRef, Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CreateAgendaComponent } from './create-agenda/create-agenda.component';
import { AgendaDto, AgendaServiceProxy } from '@shared/service-proxies/service-proxies';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EditAgendaComponent } from './edit-agenda/edit-agenda.component';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { CustomCalendarComponent } from '../custom-calendar/custom-calendar.component';

@Component({
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.scss'],
    animations: [appModuleAnimation()]
})
export class AgendaComponent extends AppComponentBase implements OnInit, OnDestroy {
    private _subscriptions: Subscription[] = [];
    protected agendas: AgendaDto[];
    protected agenda: AgendaDto;
    protected dropdownOpen: boolean = false;
    protected selectedView: string = 'agendar';
    @ViewChild('calendario') calendarComponent: CustomCalendarComponent;

    constructor(
        injector: Injector,
        private _modalService: BsModalService,
        private _agendaService: AgendaServiceProxy,
        private _cdr: ChangeDetectorRef
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this._subscriptions.push(this.getAgendas());
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(s => s.unsubscribe());
    }

    protected selectView(view: string): void {
        this.selectedView = view;
    }

    protected toggleDropdown(): void {
        this.dropdownOpen = !this.dropdownOpen;
        this._cdr.detectChanges();
    }

    protected selectAgenda(id: string, event: MouseEvent): void {
        event.stopPropagation();
        this.agenda = this.agendas.find(agenda => agenda.id === id);
        this.dropdownOpen = false;
        this._cdr.detectChanges();
        this.calendarComponent.getEventos();
    }

    protected get getSelectedAgendaName(): string {
        return this.agenda?.nomeSala ?? 'Escolha uma agenda';
    }

    protected criarAgenda(): void {
        const createModal = this._modalService.show(
            CreateAgendaComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
            }

        );

        createModal.content.onSave.subscribe(() => {
            abp.notify.success("Agenda criada com sucesso!");
            this.refresh();
        });
    }

    protected editarAgenda() {
        const createModal = this._modalService.show(
            EditAgendaComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
                initialState: {
                    id: this.agenda.id
                },
            }
        );

        createModal.content.onSave.subscribe(() => {
            abp.notify.success("Agenda editada com sucesso!");
            this.refresh();
        });

        createModal.content.onDelete.subscribe(() => {
            this.agenda = null;
            this.refresh();
        });

        createModal.content.onSuspensaoAlterada.subscribe((suspenso: boolean) => {
            this.agenda.suspenso = suspenso;
        });
    }

    private refresh(): void {
        this._subscriptions.push(this.getAgendas());
    }

    private getAgendas(): Subscription {
        abp.ui.setBusy();
        return this._agendaService
            .getAll(
                this.appSession.clinicaId,
                this.appSession.profissionalId,
                null,
                0,
                100
            )
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy();
                })
            ).subscribe((result) => {
                this.agendas = result.items;
                if (this.agendas.length > 0) {
                    this.agenda = this.agendas[0];
                }
            })
    }
}
